import axiosInstance from "../config/axios.config";

// Every facility in the organisation with its billing policy and the full
// version history behind it - what the Billing Policies list is drawn from.
export const getAllBillingPoliciesApi = () => {
  return axiosInstance.get(`billing/billing-policies/`);
};

export const getBillingPoliciesApi = (facilityId) => {
  return axiosInstance.get(`billing/facility/${facilityId}/billing-policies/`);
};

export const createBillingPolicyApi = (facilityId, payload) => {
  // payload: { billing_mode, configuration, effective_from }
  return axiosInstance.post(`billing/facility/${facilityId}/billing-policies/`, payload);
};

export const updateBillingPolicyApi = (policyId, payload) => {
  return axiosInstance.patch(`billing/billing-policies/${policyId}/`, payload);
};

export const cancelBillingPolicyApi = (policyId) => {
  return axiosInstance.post(`billing/billing-policies/${policyId}/cancel/`);
};

export const previewBillingPolicyApi = (payload) => {
  // payload: { facility_id, billing_mode, configuration, stays: [{ kind, label, start, end, rate }] }
  return axiosInstance.post(`billing/billing-policies/preview/`, payload);
};
